/**
 * Frontend version — bump on every feature/hotfix branch so atlas-tracked
 * deploys show the correct shipped version.
 */
export const VERSION = '4.4.3';
